/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FileNameDeploymentDiscoveryConfig = {
    type: FileNameDeploymentDiscoveryConfig.type;
    /**
     *
     * Regular expression pattern with named capture groups to extract deployment information from filenames.
     *
     * The pattern can include named capture groups, which can be referenced elsewhere in the configuration using {{curly_braces}}
     * Example:
     * - If "Vehicles/Neptune/(?P<parent_id>NTN\d+)/OpenRVDAS/raw/HiPAP_.*.txt" discovers two distinct parent_id values, 'NTN0123' and 'NTN0456',
     * two HiPAP deployments will be generated, and {{parent_id}} can be used elsewhere in the deployment configuration to
     * reference the parent ID for each of the HiPAP deployments.
     *
     */
    pattern: string;
    /**
     *
     * Template string to generate the deployment's external ID.
     * References named capture groups from the pattern.
     *
     * Example: "{{parent_id}}_HiPAP"
     *
     */
    external_id_template: string;
    /**
     *
     * Template string to generate the deployment's display name.
     * References named capture groups from the pattern.
     *
     * Example: "{{parent_id}}_HiPAP"
     *
     */
    name_template: string;
};

export namespace FileNameDeploymentDiscoveryConfig {

    export enum type {
        FILENAME = 'filename',
    }


}

